<template>
  <BlogPostLayout>
    <template #image>
      <BlogHeader
        :title="postData.title"
        :excerpt="postData.excerpt"
        :image="postData.image"
        :author="postData.author"
        :date="postData.date"
        :updatedAt="postData.updatedAt"
        :categories="postData.categories"
        :readTime="postData.readTime"
      />
    </template>
    <template #content>
      <article class="blog-content">
        <section class="intro">
          <p>
            The virtual tour photography market is growing faster than the
            supply of skilled providers. Real estate agents, hotels, gyms, and
            restaurants are actively looking for freelancers who can create
            professional virtual tours. This guide shows you exactly how to
            start, price, and scale a virtual tour services business targeting
            real estate agents.
          </p>
        </section>

        <section>
          <h2>Why Real Estate Agents Are Your Best First Clients</h2>
          <p>
            Real estate agents list multiple properties per month and need
            virtual tours for every listing. Once you establish yourself as
            their trusted virtual tour provider, you can generate recurring
            monthly income from a small number of regular clients. A portfolio
            of just 10 active agent clients, each needing 2–4 tours per month,
            can generate $3,000–$8,000/month.
          </p>
        </section>

        <section>
          <h2>How to Price Your Virtual Tour Services</h2>
          <h3>Per-Property Pricing</h3>
          <p>
            <strong>Studio/1-bed apartment:</strong> $150–$250.
            <strong>2–3 bedroom home:</strong> $250–$400.
            <strong>Luxury property (4+ beds):</strong> $400–$800.
            <strong>Commercial property:</strong> $500–$1,500.
          </p>
          <h3>Monthly Retainer (Best for Agent Clients)</h3>
          <p>
            Offer agents a monthly package: $600/month for up to 4 tours,
            $1,000/month for up to 8 tours. Retainers give you predictable
            income and give agents a cost-effective deal on a per-tour basis.
          </p>
        </section>

        <section>
          <h2>How to Find Your First Real Estate Agent Clients</h2>
          <h3>Cold Outreach</h3>
          <p>
            Research top-performing agents in your area on Zillow or
            Realtor.com. Find agents with many listings but no virtual tours —
            these are your warmest prospects. Send a brief email offering a free
            sample tour for their next listing, no obligation.
          </p>
          <h3>Local Networking</h3>
          <p>
            Attend local real estate association meetups. Bring a tablet showing
            sample tours you've created with Travvir. Agents who see a live demo
            almost always request more information.
          </p>
          <h3>Build a Portfolio Website</h3>
          <p>
            Create a simple website with 5–10 sample tours embedded using
            Travvir's iframe code. A portfolio website positions you as an
            established professional and handles inbound enquiries
            automatically.
          </p>
        </section>

        <section>
          <h2>Upsell Services to Increase Revenue Per Client</h2>
          <p>
            Beyond the virtual tour itself: floor plan sketching (+$50–$150),
            professional photography (+$100–$300), social media cut-downs
            (+$50), and Google Business Profile upload (+$50). Bundling these
            services increases your average revenue per property significantly.
          </p>
        </section>
        <section>
          <h2>Continue Reading</h2>
          <ul>
          <li><a href="/blog/en/virtual-tour-videographer">Become a Virtual Tour Videographer</a></li>
          <li><a href="/blog/en/virtual-tour-pricing-guide">Virtual Tour Pricing Guide</a></li>
          <li><a href="/blog/en/real-estate-virtual-tour-cost">RE Tour Cost Breakdown</a></li>
          <li><a href="/blog/en/virtual-tour-lead-generation">Lead Generation Strategies</a></li>
          <li><a href="/blog/en/how-to-make-virtual-tour-real-estate">Make RE Virtual Tours</a></li>
          <li><a href="/blog/en/best-virtual-tour-software-real-estate">Best RE Software</a></li>
          </ul>
        </section>


        <RelatedPosts
          :currentSlug="postData.slug"
          :currentCategories="postData.categories"
        />
      </article>
    </template>
  </BlogPostLayout>
</template>

<script setup>
import blogPostsData from "~/data/blogPosts.json";
const postData = blogPostsData.find(
  (p) => p.slug === "how-to-sell-virtual-tour-services",
);

useBlogSeo({
  title:
    "Sell Virtual Tour Services to Realtors [Playbook] | Travvir",
  description:
    "How to sell virtual tour services to real estate agents in 2026. Complete playbook covering pricing, pitch scripts, demo strategies, and scaling your business.",
  keywords:
    "sell virtual tour services, virtual tour business, virtual tour photography business, virtual tour freelancer, real estate virtual tour services",
  slug: "how-to-sell-virtual-tour-services",
  image: postData.image,
  postData,
});
</script>
